import { MutationTree } from 'vuex'
import * as types from './types';

export default <MutationTree<workflow.state.WorkflowState>>{
    [types.WORKFLOW_CURRENT](state, item: any) {
        state.workflows.current = item;
    },

    [types.GET_WORKFLOW_OPTIONS](state, payload: { system: any; application: any; }){
        state.options = payload;
    },
}
